module.exports = __webpack_public_path__ + "images/backgrounds/fall/large.a42f50fe10ff082519a4.jpg";